module.exports = __webpack_public_path__ + "2021315:5185b0787db23a9cf11c/img/hero-title-img@2x.6252527.png";